// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Model = require("./model");
var React = require("react");
var Slugify = require("./slugify");
var Amendement = require("./amendement");
var MaterialUI = require("bs-material-ui/lib/js/src/MaterialUI.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");
var MaterialUIIcons = require("bs-material-ui-icons/lib/js/src/MaterialUIIcons.js");
var DiscussionLayout = require("./discussionLayout");

var component = ReasonReact.reducerComponent("DiscussionFull");

function make(discussion, onNavigateToAmendement, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function (self) {
      var match = self[/* state */2][/* linkedContentDialog */0];
      var tmp;
      if (match) {
        var billPage = match[0][/* billPage */1];
        var match$1 = billPage[/* titre */3];
        tmp = ReasonReact.element(/* None */0, /* None */0, MaterialUI.Dialog[/* make */0](/* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* true */1], /* None */0, /* None */0, /* Some */[(function () {
                      return Curry._1(self[/* send */4], /* CloseLinkedContent */0);
                    })], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* true */1], /* None */0, /* array */[
                  ReasonReact.element(/* None */0, /* None */0, MaterialUI.AppBar[/* make */0](/* Some */["static"], /* None */0, /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.Toolbar[/* make */0](/* None */0, /* None */0, /* None */0, /* Some */[{
                                        display: "flex",
                                        justifyContent: "space-between"
                                      }], /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUI.IconButton[/* make */1](/* None */0, /* None */0, /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[(function () {
                                                    return Curry._1(self[/* send */4], /* CloseLinkedContent */0);
                                                  })], /* array */[ReasonReact.element(/* None */0, /* None */0, MaterialUIIcons.Close[/* make */0](/* array */[]))]))]))])),
                  ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h3"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Display1 */3], /* array */[Model.ste(billPage[/* numero */1])])),
                  match$1 ? ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h4"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Title */5], /* array */[Model.ste(match$1[0])])) : null,
                  React.createElement("div", {
                        style: {
                          wordWrap: "break-word"
                        },
                        dangerouslySetInnerHTML: {
                          __html: billPage[/* body */0]
                        }
                      })
                ]));
      } else {
        tmp = null;
      }
      return React.createElement("div", undefined, tmp, ReasonReact.element(/* None */0, /* None */0, DiscussionLayout.make(discussion, onNavigateToAmendement, /* array */[React.createElement("div", {
                                style: {
                                  backgroundColor: "#f0f0f0",
                                  display: "flex",
                                  alignItems: "center",
                                  flexDirection: "column"
                                }
                              }, ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* None */0, /* None */0, /* None */0, /* Some */["h1"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Display2 */2], /* array */[Model.ste(discussion[/* titre */8])])), React.createElement("div", {
                                    style: {
                                      display: "flex",
                                      maxWidth: "800px",
                                      alignItems: "stretch",
                                      flexDirection: "column"
                                    }
                                  }, $$Array.map((function (division) {
                                          return React.createElement("section", {
                                                      key: division[/* place */0],
                                                      id: Curry._1(Slugify.slugify, division[/* place */0])
                                                    }, ReasonReact.element(/* None */0, /* None */0, MaterialUI.Typography[/* make */3](/* Some */[/* Center */2], /* None */0, /* None */0, /* Some */["h2"], /* Some */[/* Inherit */1], /* None */0, /* None */0, /* None */0, /* None */0, /* None */0, /* Some */[/* Display1 */3], /* array */[Model.ste(division[/* place */0])])), $$Array.map((function (amendementWrapper) {
                                                            return ReasonReact.element(/* Some */[amendementWrapper[/* numero */11]], /* None */0, MaterialUI.Paper[/* make */0](/* None */0, /* None */0, /* None */0, /* Some */[4], /* Some */[Curry._1(Slugify.slugify, amendementWrapper[/* numero */11])], /* None */0, /* Some */[{
                                                                              marginTop: "24px",
                                                                              padding: "16px"
                                                                            }], /* array */[ReasonReact.element(/* None */0, /* None */0, Amendement.make(amendementWrapper, discussion, (function (amendement, linkedContentPage, _) {
                                                                                        return Curry._1(self[/* send */4], /* OpenLinkedContent */[
                                                                                                    amendement,
                                                                                                    linkedContentPage
                                                                                                  ]);
                                                                                      }), /* array */[]))]));
                                                          }), $$Array.of_list(List.filter((function (amendement) {
                                                                      return +(amendement[/* place */13] === division[/* place */0]);
                                                                    }))($$Array.to_list(discussion[/* amendements */0])))));
                                        }), discussion[/* divisions */3])))])));
    });
  newrecord[/* initialState */10] = (function () {
      return /* record */[
              /* linkedContentDialog : None */0,
              /* todo */0
            ];
    });
  newrecord[/* reducer */12] = (function (action, state) {
      if (action) {
        return /* Update */Block.__(0, [/* record */[
                    /* linkedContentDialog : Some */[/* record */[
                        /* amendement */action[0],
                        /* billPage */action[1]
                      ]],
                    /* todo */state[/* todo */1]
                  ]]);
      } else {
        return /* Update */Block.__(0, [/* record */[
                    /* linkedContentDialog : None */0,
                    /* todo */state[/* todo */1]
                  ]]);
      }
    });
  return newrecord;
}

exports.component = component;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/discussionFull.re
// module id = 1670
// module chunks = 0